var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedgerwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_1133685_cc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M80.854,47.177V46.35a1.68,1.68,0,0,0-1.678-1.678h-7.5a1.683,1.683,0,0,0-.325.032l-.012,0-.017,0A1.686,1.686,0,0,0,70,46.35V56.642a1.68,1.68,0,0,0,1.678,1.678H73.14v.58a1.68,1.68,0,0,0,1.678,1.678h7.5A1.68,1.68,0,0,0,84,58.9V50.69Zm-.064.775,2.294,2.564H80.789Zm-7.649.657v9.147H71.675a1.115,1.115,0,0,1-1.113-1.113V46.35a1.118,1.118,0,0,1,.879-1.089l.009,0h.007a1.12,1.12,0,0,1,.219-.022h7.5a1.115,1.115,0,0,1,1.113,1.114v.58H74.818A1.68,1.68,0,0,0,73.14,48.608ZM83.432,58.9a1.115,1.115,0,0,1-1.113,1.113h-7.5A1.115,1.115,0,0,1,73.7,58.9V48.608a1.115,1.115,0,0,1,1.113-1.114h5.406V51.08h3.208V58.9Z",
    transform: "translate(-69.997 -44.672)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 6.686,
    height: 0.565,
    transform: "translate(5.315 12.097)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 0.565,
    height: 2.76,
    transform: "translate(5.63 7.915)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 0.565,
    height: 1.63,
    transform: "translate(7.445 9.045)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 0.565,
    height: 2.383,
    transform: "translate(9.299 8.292)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 0.565,
    height: 3.136,
    transform: "translate(11.114 7.539)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerwise);
export default __webpack_public_path__ + "static/media/ledgerwise.3c2da1c33cec402526836e4a1ba916e5.svg";
export { ForwardRef as ReactComponent };